<template>
<div class="animated fadeIn">
  <v-client-table :data="buildings" :columns="columns" :options="options" :theme="theme" id="buildingDataTable">
    <template slot="select" slot-scope="data">
      <b-btn variant="outline-primary" v-if="numberOfRooms > 0 && data.row.avail_rooms >= numberOfRooms" @click="selectBuilding(data.row.id)">Select</b-btn>
    </template>
  </v-client-table>
</div>
</template>

<script>
import Vue from 'vue'
import {
  mapState,
} from 'vuex'


export default {
  name: "BuildingAutoSearch",
  props: {
    reservation: Object
  },
  computed: {
    buildings() {
      let items = this.$store.state.reservations.availableBuildings

      return items
    },
    ...mapState({
      availRooms: state => state.reservations.availableRooms,
    })
  },
  data() {
    return {
      numberOfRooms: 0,
      columns: [
        'name',
        'total_rooms',
        'avail_rooms',
        'select'
      ],
      options: {
        headings: {
          name: 'Name',
          total_rooms: 'Total Rooms',
          avail_rooms: 'Available Rooms',
        },
        sortable: [],
        filterable: [],
        sortIcon: {
          base: 'fa',
          up: 'fa-sort-asc',
          down: 'fa-sort-desc',
          is: 'fa-sort'
        },
        pagination: {
          chunk: 5,
          edge: true,
          nav: 'scroll'
        },
        perPage: 25,
      },
      theme: 'bootstrap4',
    }
  },
  methods: {
    setNumberOfRooms(numberOfRooms) {
      this.numberOfRooms = numberOfRooms
    },
    selectBuilding(buildingId) {
      this.$emit('selected', buildingId)
    },
    refresh() {
      this.$store.dispatch('reservations/searchAvailableRooms', {arrival: this.formatDate(this.reservation.arrival_date), departure: this.formatDate(this.reservation.departure_date)})
    }
  },
  created() {
    this.refresh()
  }
}
</script>
